const currencyFormatter = (number) => {
  const formatter = new Intl.NumberFormat("en-US");
  const formattedNumber = formatter.format(parseInt(number, 10));
  return formattedNumber;
};

export default currencyFormatter;
